import { render, staticRenderFns } from "./createProjectOverview.vue?vue&type=template&id=1bf976ee&scoped=true&"
import script from "./createProjectOverview.vue?vue&type=script&lang=js&"
export * from "./createProjectOverview.vue?vue&type=script&lang=js&"
import style0 from "./createProjectOverview.vue?vue&type=style&index=0&id=1bf976ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf976ee",
  null
  
)

export default component.exports